import { CoreEnums } from '@/utils/domain/constants';
import { getIntl } from 'umi';

const { ChatMessageContentItemType } = CoreEnums;

export const validateUrl = async (url) => {
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

export const handleUrlSubmit = async (url) => {
  const intl = getIntl();
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch (error) {
    return { error: intl.formatMessage({ id: 'supportChat.invalidUrl' }) };
  }

  try {
    const response = await fetch(parsedUrl.href, { method: 'HEAD' });
    if (!response.ok) {
      return { error: intl.formatMessage({ id: 'supportChat.cannotAccessResource' }) };
    }

    const contentType = response.headers.get('Content-Type');
    if (!contentType) {
      return { error: intl.formatMessage({ id: 'supportChat.cannotDetermineContentType' }) };
    }

    let itemType;
    let name;
    if (contentType.startsWith('image/')) {
      return {
        imageUrl: parsedUrl.href,
        contentType,
        type: ChatMessageContentItemType.ImageUrl,
        name: parsedUrl.href,
      };
    } else if (contentType.startsWith('audio/')) {
      return {
        audioUrl: parsedUrl.href,
        contentType,
        type: ChatMessageContentItemType.AudioUrl,
        name: parsedUrl.href,
      };
    } else if (
      contentType === 'application/pdf' ||
      contentType === 'application/msword' ||
      contentType.startsWith('application/vnd.')
    ) {
      return {
        documentUrl: parsedUrl.href,
        contentType,
        type: ChatMessageContentItemType.DocumentUrl,
        name: parsedUrl.href,
      };
    } else {
      return { error: intl.formatMessage({ id: 'supportChat.invalidContentType' }) };
    }
  } catch (error) {
    return { error: intl.formatMessage({ id: 'supportChat.errorGettingContentType' }) };
  }
};

export const getType = (file) => {
  return new Promise((resolve, reject) => {
    const intl = getIntl();
    const allowedTypes = ['image', 'audio'];

    if (!file.type.startsWith(allowedTypes[0]) && !file.type.startsWith(allowedTypes[1])) {
      reject(new Error(intl.formatMessage({ id: 'supportChat.fileTypeNotAllowed' })));
      return;
    }
    const contentType = file.type;
    const name = file.name;
    let itemType;
    if (file.type.startsWith(allowedTypes[0])) {
      itemType = ChatMessageContentItemType.ImageUrl;
      resolve({ contentType, type: itemType, name });
    } else if (file.type.startsWith(allowedTypes[1])) {
      itemType = ChatMessageContentItemType.AudioUrl;
      resolve({ contentType, type: itemType, name });
    }
  });
};

/**
 * Filters out automatic welcome messages from a messages array
 * Currently disabled as the filtering was too aggressive and blocked legitimate messages
 * @param {Array} messages - Array of messages to filter
 * @returns {Array} - Returns all messages without filtering
 */
export const filterAutomaticWelcomeMessages = (messages) => {
  // Filter disabled - was removing legitimate messages
  // Simply return all messages without any filtering
  return messages;
};
